export function rgbaToHex(color) {
  // Check if the color is in rgba() or rgb() format
  if (typeof color === "string" && color.startsWith("rgb")) {
    const match = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
    if (!match) return "#000000"; // fallback
    const [r, g, b] = match.slice(1, 4).map(Number);
    return (
      "#" +
      [r, g, b]
        .map((x) => {
          const hex = x.toString(16);
          return hex.length === 1 ? "0" + hex : hex;
        })
        .join("")
    );
  }

  // Return the original color if it's already a hex
  return color;
}
